export const CRITICAL_ILLNESS_MAX_AGE = 60;
export const CRITICAL_ILLNESS_END_AGE = 67;
export const AKA_CRITICAL_ILLNESS_MAX_AGE = 61;
export const AKA_CRITICAL_ILLNESS_END_AGE = 67;
